var _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdjusticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5666 10.4426C17.0416 10.6854 17.5798 10.8224 18.1499 10.8224C18.7201 10.8224 19.2582 10.6854 19.7333 10.4426L19.7333 20.6391C19.7333 21.5136 19.0244 22.2224 18.1499 22.2224C17.2755 22.2224 16.5666 21.5136 16.5666 20.6391L16.5666 10.4426ZM16.5666 4.23552L16.5666 2.69466C16.5666 1.82021 17.2755 1.11133 18.1499 1.11133C19.0244 1.11133 19.7333 1.82021 19.7333 2.69466L19.7333 4.23558C19.2582 3.99272 18.7201 3.85574 18.1499 3.85573C17.5798 3.85573 17.0416 3.9927 16.5666 4.23552Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0444,
    cy: 7.44457,
    r: 2.95556,
    transform: "rotate(90 18.0444 7.44457)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47786 10.4426C3.9529 10.6854 4.49103 10.8224 5.06116 10.8224C5.63131 10.8224 6.16948 10.6854 6.64453 10.4426L6.64453 20.6391C6.64453 21.5136 5.93565 22.2224 5.0612 22.2224C4.18675 22.2224 3.47786 21.5136 3.47786 20.6391L3.47786 10.4426ZM3.47786 4.23553L3.47786 2.69466C3.47786 1.82021 4.18675 1.11133 5.0612 1.11133C5.93565 1.11133 6.64453 1.82021 6.64453 2.69466L6.64453 4.23557C6.16948 3.99272 5.63131 3.85574 5.06116 3.85573C4.49103 3.85573 3.9529 3.9927 3.47786 4.23553Z",
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.95558,
    cy: 7.44457,
    r: 2.95556,
    transform: "rotate(90 4.95558 7.44457)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0222 12.8919C10.4972 12.6491 11.0353 12.5121 11.6055 12.5121C12.1756 12.5121 12.7138 12.6491 13.1888 12.892L13.1888 2.69537C13.1888 1.82092 12.48 1.11203 11.6055 1.11203C10.7311 1.11203 10.0222 1.82092 10.0222 2.69537L10.0222 12.8919ZM10.0222 19.099L10.0222 20.6398C10.0222 21.5143 10.7311 22.2231 11.6055 22.2231C12.48 22.2231 13.1888 21.5143 13.1888 20.6398L13.1888 19.0989C12.7138 19.3418 12.1756 19.4788 11.6055 19.4788C11.0353 19.4788 10.4972 19.3418 10.0222 19.099Z",
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.95556,
    cy: 2.95556,
    r: 2.95556,
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 14.4556 18.8455)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjusticon);
export default __webpack_public_path__ + "static/media/adjust.icon.a0d5c74709f1d79a9b2c451d86bbc5d9.svg";
export { ForwardRef as ReactComponent };